var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "21px",
    viewBox: "0 0 22 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "format-text") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Uploads-Flow-+-New-Doc-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-303.000000, -1011.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "format-text",
    transform: "translate(303.000000, 1011.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2539683,0 L21.8742857,6.07619048 L20.5333333,6.43936508 C19.9047619,5.22412698 19.2622222,4.00888889 18.5219048,3.39428571 C17.7815873,2.79365079 16.9155556,2.79365079 16.0634921,2.79365079 L12.5714286,2.79365079 L12.5714286,17.4603175 C12.5714286,18.1587302 12.5714286,18.8571429 13.032381,19.2063492 C13.5073016,19.5555556 14.4292063,19.5555556 15.3650794,19.5555556 L15.3650794,20.952381 L6.98412698,20.952381 L6.98412698,19.5555556 C7.92,19.5555556 8.84190476,19.5555556 9.3168254,19.2063492 C9.77777778,18.8571429 9.77777778,18.1587302 9.77777778,17.4603175 L9.77777778,2.79365079 L6.28571429,2.79365079 C5.43365079,2.79365079 4.56761905,2.79365079 3.82730159,3.39428571 C3.08698413,4.00888889 2.44444444,5.22412698 1.81587302,6.43936508 L0.474920635,6.07619048 L2.0952381,0 L20.2539683,0 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormating);
export default __webpack_public_path__ + "static/media/formating.2a254dc0b904c37403572423a8844c14.svg";
export { ForwardRef as ReactComponent };